import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'

import { Typography } from 'antd'
const { Title } = Typography

export const MainText = ({ editable, title, text, editTitle, editText }) => {
  const [isEditing, setEditing] = useState({ title: false, sub: false })

  return (
    <Fragment>
      <Title
        level={2}
        style={{
          color: '#295EC9',
          cursor: editable ? 'pointer' : 'default',
        }}
        id='title'
        maxLength={25}
        onClick={() =>
          setEditing({ title: !isEditing.title, sub: isEditing.sub })
        }
        editable={
          editable
            ? {
                editing: isEditing.title,
                onChange: title => {
                  editTitle(title)
                  setEditing({ title: false, sub: isEditing.sub })
                },
              }
            : false
        }
      >
        {title}
      </Title>

      <Title
        level={3}
        style={{
          color: 'white',
          cursor: editable ? 'pointer' : 'default',
        }}
        id='sub'
        maxLength={25}
        onClick={() =>
          setEditing({ title: isEditing.title, sub: !isEditing.sub })
        }
        editable={
          editable
            ? {
                editing: isEditing.sub,
                onChange: sub => {
                  editText(sub)
                  setEditing({ title: isEditing.title, sub: false })
                },
              }
            : false
        }
      >
        {text}
      </Title>
    </Fragment>
  )
}

MainText.propTypes = {
  /** String chosen by the user to be the title of the gift page, the default is 'Parabéns!' */
  title: PropTypes.string,

  /** String chosen by the user to be the text of the gift page, the default is 'Sua compra foi processada e está disponível para resgate!' */
  text: PropTypes.string,

  /** Function to be executed for edit de gift page text */
  editText: PropTypes.func,

  /** Function to be executed for edit de gift page title */
  editTitle: PropTypes.func,

  /** Boolean value representing if the title and the text are editable (if is gift) */
  editable: PropTypes.bool.isRequired,
}
